import Marquee from "react-fast-marquee";

const unis = [
  { name: "MIT", domain: "mit.edu" },
  { name: "Stanford", domain: "stanford.edu" },
  { name: "Harvard", domain: "harvard.edu" },
  { name: "Oxford", domain: "ox.ac.uk" },
  { name: "Cambridge", domain: "cam.ac.uk" },
  { name: "Imperial", domain: "imperial.ac.uk" },
  { name: "Toronto", domain: "utoronto.ca" },
  { name: "Melbourne", domain: "unimelb.edu.au" },
  { name: "Trinity", domain: "tcd.ie" },
  { name: "UCD", domain: "ucd.ie" },
  { name: "Carnegie Mellon", domain: "cmu.edu" },
  { name: "UC Berkeley", domain: "berkeley.edu" },
  { name: "Auckland", domain: "auckland.ac.nz" },
  { name: "Monash", domain: "monash.edu" },
  { name: "Adelaide", domain: "adelaide.edu.au" },
];

const logoUrl = (d) =>
  `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${d}&size=128`;

export default function UniversitiesMarquee() {
  return (
    <section className="py-6 border-y-[3px] border-[#282829] bg-[#282829]" data-testid="universities-marquee">
      <Marquee gradient={false} speed={65} pauseOnHover>
        {unis.map((u, i) => (
          <div
            key={u.name + i}
            className="pill3d flex items-center gap-3 mx-4 px-6 py-4 rounded-full min-w-[230px] border-2 border-[#282829]"
            title={u.name}
          >
            <div className="w-11 h-11 rounded-full bg-white border-2 border-[#282829] grid place-items-center flex-shrink-0 overflow-hidden">
              <img
                src={logoUrl(u.domain)}
                alt={u.name}
                className="w-8 h-8 object-contain"
                loading="lazy"
              />
            </div>
            <span className="font-anton text-xl text-[#282829] tracking-wide truncate">{u.name}</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
